import qs from 'query-string';
import { API_ENDPOINT, getV1FaqAskOptions } from '../../resources/@types/devopsSchema';

export const getFaqAskOptions = ({ searchValue }: { searchValue: string }) => {
  return getV1FaqAskOptions({
    queryKey: [API_ENDPOINT.V1_FAQ_ASK, { searchValue }],
    url: qs.stringifyUrl({
      url: API_ENDPOINT.V1_FAQ_ASK,
      query: {
        question: searchValue,
      },
    }),
  });
};
